module.exports = __webpack_public_path__ + "static/icon_pick_up_default_carf0e801b79e0c684d19fbaa3ea46d3b1d.png";